/** Client timeout for POST /tradiefileshare (zip + upload + email can be slow). */
export const TRADIEFILESHARE_EXPORT_TIMEOUT_MS = 600000

/** Client timeout for POST /tradiefileshare/size (storage size() per file). */
export const TRADIEFILESHARE_SIZE_TIMEOUT_MS = 180000

/**
 * One entry per tradie id for the share payload (backend expects unique tradies).
 * @param {Array<{ id?: number }>} entries
 * @returns {Array}
 */
export function uniqueTradieShareEntries(entries) {
  const byId = new Map()
  for (const entry of entries || []) {
    if (!entry || entry.id == null) continue
    const id = entry.id
    if (!byId.has(id)) byId.set(id, entry)
  }
  return [...byId.values()]
}

const HIDDEN_PERSONAL_INFO_KEYS = [
  'Files',
  'excluded',
  'Id',
  'Avatar Permanent Url',
  'Avatar Permanent Thumb Url',
  'Profile Photo',
  'Signup Consent Given',
  'Ai Consent Given',
  'Manual Upload Consent Given',
  'Privacy Consent Given',
  'Signup Consent Given At',
  'Ai Consent Given At',
  'Manual Upload Consent Given At',
  'Requires Password Change',
  'Country Code',
]

/** Whether a tradie field is listed as a tick box under Personal Information. */
export function isPersonalInfoRow(key) {
  return !key.startsWith('_') && !HIDDEN_PERSONAL_INFO_KEYS.includes(key)
}

/** True when at least one Personal Information row is still ticked. */
export function hasTickedPersonalInfo(user) {
  const unticked = (user.excluded && user.excluded.personal_info) || []
  return Object.keys(user).some(
    (key) => isPersonalInfoRow(key) && !unticked.includes(key),
  )
}
